import { Badge } from "./Badge";
import { ClockIcon, ShieldCheckIcon } from "./icons";

export type VerificationStatus = "verified" | "pending" | "unverified";

type Props = {
  label: string;
  /** New API: explicit verification status (always renders). */
  status?: VerificationStatus;
  /** Legacy API: render only when true, as a "verified" badge. */
  verified?: boolean;
};

const icons: Record<VerificationStatus, React.ReactNode> = {
  verified: <ShieldCheckIcon className="h-3.5 w-3.5" />,
  pending: <ClockIcon className="h-3.5 w-3.5" />,
  unverified: null,
};

const tones = {
  verified: "accent",
  pending: "warning",
  unverified: "neutral",
} as const;

export const VerificationBadge = ({ label, status, verified }: Props) => {
  // Legacy callers pass `verified` and expect nothing when false.
  if (status === undefined) {
    if (!verified) return null;
    return (
      <Badge tone="accent" icon={icons.verified}>
        {label}
      </Badge>
    );
  }

  return (
    <Badge tone={tones[status]} icon={icons[status]}>
      {label}
    </Badge>
  );
};
